/** @type {import('../help-index.js').HelpSidebarItem} */
export const TAX_IVA_DDJJ_COMPRAS_ITEM = {
  id: 'sub_nav_3',
  screenId: 'tax-iva-ddjj-libro-compras',
  label: 'DDJJ — Libro IVA Compras',
  description: 'Consulta del libro IVA compras del sistema.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Mismo criterio que ventas pero para facturas de compra: crédito fiscal, bases e IVA por comprobante de proveedor.',
      },
      {
        title: 'Paso 1 — Filtrar',
        fields: [
          { label: 'Desde / Hasta', description: 'Rango de fechas. Tocá «Buscar».' },
        ],
      },
      {
        title: 'Paso 2 — Leer la lista',
        bullets: [
          'Columnas: fecha, comprobante, proveedor, identificación, neto, IVA, total.',
          'Tocá una fila para ver la factura de compra. Exportable.',
        ],
      },
    ],
  },
}
